var ProductImages = /*@__PURE__*/ (function () {
    function ProductImages() {
    }
    return ProductImages;
}());
export { ProductImages };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/product/product.images.ts
// module id = null
// module chunks = 